import { useState, useEffect, useContext, useRef } from "react";
import { NavLink, useLocation, Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import undrawProfile from "../img/undraw_profile.svg";
import arrow from "../img/arrow.png";
import UserMenu from "./UserMenu";
import axiosHttp from "../config/axios.interceptor";
import useClickOutside from "../Hooks/UseClickOutside";
import { errorResponseMessage, followerApiStatus } from "../shared/const.prop";
import { AppContext } from "../contexts/AppContext";
import logoImage from "../views/Components/HeroSection/assets/logo.png";
import {
  getFollowerSuggestion,
  getFollowersList,
} from "../store/actions/userActions";
import { AuthContext } from "../contexts/AuthContext";
import { truncateText } from "../../utils/application-helper";
import { toast } from "react-toastify";
import OtpVerification from "./OtpVerification";
import { getActiveNotificationCount } from "../store/actions/notificationAction";
import { getActiveChatNotificationCount } from "../store/actions/chatNotificationAction";

const Nav = ({ isNotLoggedIn = false }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [query, setQuery] = useState("");
  const location = useLocation();
  const { userData } = useSelector((state) => state.user);
  const { activeNotificationCount } = useSelector(
    (state) => state.notification
  );
  const [searchResults, setSearchResults] = useState([]);
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isOpen, toggle, containerRef] = useClickOutside(false);
  const [isContainerOpen, setIsContainerOpen] = useState(false);
  const searchContainerRef = useRef(null);
  const [navActive, setNavActive] = useState(location.pathname);
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const userId = user?.userId || user?.data?.data?.userId;
  const userName = user?.userName || user?.data?.data?.userName;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchContainerRef.current &&
        !searchContainerRef.current.contains(event.target)
      ) {
        setIsContainerOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setShowMenu(false);
    setQuery("");
    setSearchResults([]);
    setNavActive(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    const getData = setTimeout(getSearchResults, 500);
    return () => clearTimeout(getData);
  }, [query]);

  const handleInputChange = (event) => {
    setQuery(event.target.value);
    // onInput(event.target.value);
  };

  const getSearchResults = async () => {
    if (query.trim() === "") {
      setSearchResults([]);
    } else {
      try {
        const results = await axiosHttp.get(`mentor-search?name=${query}`);
        if (results.status === 200) {
          let data = results?.data?.data;
          setSearchResults(data);
        }
      } catch (error) {
        if (error.response.status === 429) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
          authContext.logout();
        }
        if (error.response.status === 400) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
        }
        if (error.response?.status >= 500) {
          appContext.updateNotificationState({
            show: true,
            message: "Something went wrong, please try again later.",
            type: "error",
          });
        }
        setSearchResults([]);
      }
    }
  };

  // const handleRequest = async (userId, status, result) => {
  //   try {
  //     const followApi = await axiosHttp.post("follow", {
  //       userId,
  //       status,
  //     });
  //     if (followApi.status === 201) {
  //       [(followerApiStatus.accept, followerApiStatus.cancel)].includes(status)
  //         ? dispatch(getFollowersList())
  //         : dispatch(getFollowerSuggestion());

  //       appContext.updateNotificationState({
  //         show: true,
  //         type: "success",
  //         message: `You started following ${result?.fname} ${result?.lname}`,
  //       });
  //       setSearchResults([]);
  //       setQuery("");
  //     }
  //   } catch (e) {
  //     appContext.updateNotificationState({
  //       show: true,
  //       type: "error",
  //       message: "Error, please try after sometime.",
  //     });
  //     console.log(e);
  //   }
  // };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const navigateHandler = (path) => {
    appContext.updateCategory("");
    setShowDropdown(false);
    if (location.pathname === path) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate(path);
    }
  };

  const handleHomeNavigation = () => {
    navigate("/home");
  };

  const handleNavigate = (userId) => {
    setSearchResults([]);
    setQuery("");
    navigate(`/${userId}`, { replace: true });
    setIsMobileSearchOpen(false);
  };

  const searchIndividualHandler = (e) => {
    e.preventDefault();
    const url = `/searchResults?search=${query}`;
    window.open(url, "_blank");
  };

  const onKeyDownHandler = (e) => {
    e.preventDefault();
    console.log("key pressed");
  };

  const buttonRef = useRef(null);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter" && buttonRef.current) {
        buttonRef.current.click();
      }
    };

    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [searchResults]);

  useEffect(() => {
    if (searchResults.length > 0) {
      setIsContainerOpen(true);
    }
  }, [searchResults]);

  // const [isOtpModalOpen, setIsOtpModalOpen] = useState(true);
  // const [isOtpDisabled, setIsOtpDisabled] = useState(false);

  // const handleOtpSubmit = async (otp) => {
  //   setIsOtpDisabled(true);
  //   let url =
  //     notificationData.refer_type === "startotp" ? "start-otp" : "end-otp";
  //   const payload = {
  //     appointment_id: notificationData.refer_id,
  //     [notificationData.refer_type === "startotp" ? "start_otp" : "end_otp"]:
  //       otp,
  //   };
  //   try {
  //     const verifyOTP = await axiosHttp.post(`appointment/${url}`, payload);
  //     if (verifyOTP.status === 200) {
  //       setIsOtpDisabled(false);
  //       setIsOtpModalOpen(false);
  //       appContext.updateNotificationState({
  //         show: true,
  //         message: "OTP verified successfully",
  //         type: "success",
  //       });
  //       dispatch(getActiveNotificationCount());
  //       dispatch(getActiveChatNotificationCount());
  //     }
  //   } catch (e) {
  //     if (e.response.status === 429) {
  //       appContext.updateNotificationState({
  //         show: true,
  //         message: errorResponseMessage(e),
  //         type: "error",
  //       });
  //       authContext.logout();
  //     }
  //     if (e.response.status === 400) {
  //       appContext.updateNotificationState({
  //         show: true,
  //         message: errorResponseMessage(e),
  //         type: "error",
  //       });
  //     }
  //   }
  // };

  return (
    <div className="container">
      <nav className="navbar navbar-expand-md navbar-light bg-white topbar mb-4  shadow fixed-top">
        <div className="container">
          <div
            className={`d-flex justify-content-start align-items-center nav-mob ${
              isMobileSearchOpen ? "nav-search-cont" : ""
            }`}
          >
            {!isMobileSearchOpen ? (
              <h3 className="ml-3 navbar-brand logo cursor-pointer">
                <img
                  src={logoImage}
                  className="w-100"
                  onClick={handleHomeNavigation}
                />
              </h3>
            ) : (
              <img
                src={arrow}
                className="search-back-arrow"
                onClick={() => setIsMobileSearchOpen(false)}
              />
            )}

            <div className="form-inline search-box d-block d-md-none">
              <div className="form-group has-search">
                <span className="form-control-feedback">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8.80401 1.5C12.8315 1.5 16.1075 4.776 16.1075 8.8035C16.1075 10.7037 15.3783 12.4367 14.185 13.7374L16.5331 16.0805C16.7528 16.3003 16.7536 16.6558 16.5338 16.8755C16.4243 16.9865 16.2796 17.0413 16.1356 17.0413C15.9923 17.0413 15.8483 16.9865 15.7381 16.877L13.3617 14.5073C12.1116 15.5084 10.5265 16.1077 8.80401 16.1077C4.77651 16.1077 1.49976 12.831 1.49976 8.8035C1.49976 4.776 4.77651 1.5 8.80401 1.5ZM8.80401 2.625C5.39676 2.625 2.62476 5.39625 2.62476 8.8035C2.62476 12.2108 5.39676 14.9827 8.80401 14.9827C12.2105 14.9827 14.9825 12.2108 14.9825 8.8035C14.9825 5.39625 12.2105 2.625 8.80401 2.625Z"
                      fill="#1C1C1C"
                      fillOpacity="0.7"
                    />
                  </svg>
                </span>
                <div className="search-container mobile-search-container">
                  <div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search"
                      value={query}
                      onChange={handleInputChange}
                      onFocus={() => {
                        setIsMobileSearchOpen(true);
                      }}
                    />
                    {/* <span className="search-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M13.0409 10.281C14.3279 10.281 15.3749 11.3227 15.3749 12.603C15.3749 13.8832 14.3279 14.925 13.0409 14.925C11.7532 14.925 10.7054 13.8832 10.7054 12.603C10.7054 11.3227 11.7532 10.281 13.0409 10.281ZM13.0409 11.406C12.3734 11.406 11.8304 11.943 11.8304 12.603C11.8304 13.2637 12.3734 13.8 13.0409 13.8C13.7077 13.8 14.2499 13.2637 14.2499 12.603C14.2499 11.943 13.7077 11.406 13.0409 11.406ZM7.56023 12.0696C7.87072 12.0696 8.12273 12.3216 8.12273 12.6321C8.12273 12.9426 7.87072 13.1946 7.56023 13.1946H2.83447C2.52397 13.1946 2.27197 12.9426 2.27197 12.6321C2.27197 12.3216 2.52397 12.0696 2.83447 12.0696H7.56023ZM4.58475 3C5.8725 3 6.9195 4.0425 6.9195 5.32275C6.9195 6.603 5.8725 7.644 4.58475 7.644C3.29775 7.644 2.25 6.603 2.25 5.32275C2.25 4.0425 3.29775 3 4.58475 3ZM4.58475 4.125C3.918 4.125 3.375 4.662 3.375 5.32275C3.375 5.98275 3.918 6.519 4.58475 6.519C5.25225 6.519 5.7945 5.98275 5.7945 5.32275C5.7945 4.662 5.25225 4.125 4.58475 4.125ZM14.3933 4.8003C14.7038 4.8003 14.9558 5.0523 14.9558 5.3628C14.9558 5.6733 14.7038 5.9253 14.3933 5.9253H9.66832C9.35782 5.9253 9.10582 5.6733 9.10582 5.3628C9.10582 5.0523 9.35782 4.8003 9.66832 4.8003H14.3933Z"
                          fill="#1C1C1C"
                          fillOpacity="0.7"
                        />
                      </svg>
                    </span> */}
                  </div>
                  {isMobileSearchOpen && (
                    <form
                      className="mobile-search-dropdown search-dropdown"
                      onKeyDown={onKeyDownHandler}
                      onSubmit={(e) => {
                        e.preventDefault();
                        searchIndividualHandler();
                      }}
                    >
                      <ul>
                        {searchResults.slice(0, 3).map((result) => (
                          <li key={result.id}>
                            <div
                              onClick={() => handleNavigate(result?.user_name)}
                            >
                              <div className="d-flex align-items-center">
                                <div className="sme-profile">
                                  <img
                                    src={result?.pic_url || undrawProfile}
                                    alt="pic"
                                    className={`img-profile rounded-circle  ml-1 ${
                                      result?.offerService
                                        ? "sme-mini-service"
                                        : null
                                    }`}
                                  />
                                  {result?.offerService && (
                                    <div className="sme-mini-icon">SME</div>
                                  )}
                                </div>
                                {`${result?.fname || ""} ${
                                  result?.lname || ""
                                }`}{" "}
                                <br />
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div
            className={`collapse navbar-collapse justify-content-between ${
              showDropdown ? "showdropdown" : ""
            }`}
            id="nav"
          >
            <ul
              className="navbar-nav"
              style={{ marginLeft: "auto", marginRight: "auto" }}
            >
              <li
                className={
                  navActive === "/home" ? "nav-item nav-active" : "nav-item"
                }
                onClick={() => navigateHandler("/home")}
              >
                <a>
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="26"
                      viewBox="0 0 25 26"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.0031 16.8399C15.4078 16.8399 16.5511 17.975 16.5511 19.3704V22.959C16.5511 23.2589 16.7914 23.4992 17.0994 23.5062H19.3231C21.0754 23.5062 22.4999 22.0992 22.4999 20.3702V10.1922C22.4918 9.59721 22.2083 9.03721 21.7218 8.66504L14.0299 2.53071C12.9974 1.71287 11.5531 1.71287 10.5171 2.53304L2.87775 8.66271C2.37259 9.04654 2.08909 9.60654 2.08325 10.212V20.3702C2.08325 22.0992 3.50775 23.5062 5.26008 23.5062H7.50475C7.82092 23.5062 8.07759 23.2554 8.07759 22.9474C8.07759 22.8797 8.08575 22.812 8.09975 22.7479V19.3704C8.09975 17.9832 9.23608 16.8492 10.6303 16.8399H14.0031ZM19.3231 25.2562H17.0784C15.7928 25.2259 14.8011 24.2167 14.8011 22.959V19.3704C14.8011 18.9399 14.4429 18.5899 14.0031 18.5899H10.6361C10.2056 18.5922 9.84975 18.9434 9.84975 19.3704V22.9474C9.84975 23.0349 9.83809 23.1189 9.81359 23.1982C9.68759 24.3532 8.70058 25.2562 7.50475 25.2562H5.26008C2.54292 25.2562 0.333252 23.064 0.333252 20.3702V10.2039C0.344919 9.04421 0.879252 7.98254 1.80209 7.28371L9.42625 1.16454C11.1051 -0.16546 13.4443 -0.16546 15.1196 1.16221L22.7986 7.28721C23.7004 7.97437 24.2348 9.03371 24.2499 10.1794V20.3702C24.2499 23.064 22.0403 25.2562 19.3231 25.2562Z"
                        fill="black"
                        fillOpacity="0.6"
                      />
                    </svg>
                  </div>
                  <div className="name">
                    <span data-text="Home">Home</span>
                  </div>
                </a>
              </li>

              <li
                className={
                  navActive.includes("myspace") ||
                  navActive.includes("my-posts") ||
                  (userName &&
                    location.pathname.trim().split("/")[1] == userName)
                    ? "nav-item nav-active"
                    : "nav-item"
                }
                onClick={() => navigateHandler(`/${userName}`)}
              >
                <a>
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                    >
                      <path
                        d="M16.5785 2.33331C16.9479 2.33331 17.2531 2.63953 17.3014 3.03682L17.3081 3.14727L17.3081 4.06729C20.3041 4.29473 22.1386 6.43868 22.1291 9.90007V19.8035C22.1291 23.4725 20.0693 25.6666 16.7588 25.6666H8.53162C5.225 25.6666 3.16138 23.4351 3.16138 19.7214V9.90007C3.16138 6.43992 5.00179 4.29538 7.99124 4.06739L7.99133 3.14727C7.99133 2.69773 8.31795 2.33331 8.72086 2.33331C9.09019 2.33331 9.39542 2.63953 9.44372 3.03682L9.45038 3.14727L9.45024 4.04715H15.8487L15.849 3.14727C15.849 2.69773 16.1756 2.33331 16.5785 2.33331ZM20.6697 11.9968H4.61979L4.62043 19.7214C4.62043 22.434 5.93189 23.9397 8.29211 24.034L8.53162 24.0387H16.7588C19.2782 24.0387 20.67 22.5561 20.67 19.8035L20.6697 11.9968ZM16.975 18.8253C17.3779 18.8253 17.7046 19.1898 17.7046 19.6393C17.7046 20.0514 17.4301 20.3919 17.074 20.4458L16.975 20.4532C16.5631 20.4532 16.2365 20.0888 16.2365 19.6393C16.2365 19.2272 16.5109 18.8867 16.867 18.8328L16.975 18.8253ZM12.6587 18.8253C13.0616 18.8253 13.3882 19.1898 13.3882 19.6393C13.3882 20.0514 13.1138 20.3919 12.7577 20.4458L12.6587 20.4532C12.2468 20.4532 11.9202 20.0888 11.9202 19.6393C11.9202 19.2272 12.1946 18.8867 12.5507 18.8328L12.6587 18.8253ZM8.33338 18.8253C8.73628 18.8253 9.0629 19.1898 9.0629 19.6393C9.0629 20.0514 8.78845 20.3919 8.43237 20.4458L8.32437 20.4532C7.92146 20.4532 7.59484 20.0888 7.59484 19.6393C7.59484 19.2272 7.86929 18.8867 8.22538 18.8328L8.33338 18.8253ZM16.975 14.6074C17.3779 14.6074 17.7046 14.9718 17.7046 15.4214C17.7046 15.8334 17.4301 16.174 17.074 16.2279L16.975 16.2353C16.5631 16.2353 16.2365 15.8709 16.2365 15.4214C16.2365 15.0093 16.5109 14.6687 16.867 14.6148L16.975 14.6074ZM12.6587 14.6074C13.0616 14.6074 13.3882 14.9718 13.3882 15.4214C13.3882 15.8334 13.1138 16.174 12.7577 16.2279L12.6587 16.2353C12.2468 16.2353 11.9202 15.8709 11.9202 15.4214C11.9202 15.0093 12.1946 14.6687 12.5507 14.6148L12.6587 14.6074ZM8.33338 14.6074C8.73628 14.6074 9.0629 14.9718 9.0629 15.4214C9.0629 15.8334 8.78845 16.174 8.43237 16.2279L8.32437 16.2353C7.92146 16.2353 7.59484 15.8709 7.59484 15.4214C7.59484 15.0093 7.86929 14.6687 8.22538 14.6148L8.33338 14.6074ZM15.8487 5.67465H9.45024L9.45038 6.71866C9.45038 7.16819 9.12376 7.53261 8.72086 7.53261C8.35153 7.53261 8.0463 7.2264 7.99799 6.8291L7.99133 6.71866L7.9903 5.69939C5.81569 5.90141 4.62043 7.35768 4.62043 9.90007L4.61979 10.3681H20.6697L20.67 9.89757C20.677 7.35319 19.4879 5.89994 17.3081 5.69914L17.3081 6.71866C17.3081 7.16819 16.9814 7.53261 16.5785 7.53261C16.2092 7.53261 15.904 7.2264 15.8557 6.8291L15.849 6.71866L15.8487 5.67465Z"
                        fill="black"
                        fillOpacity="0.6"
                      />
                    </svg>
                  </div>
                  <div className="name">
                    <span className="text-nowrap" data-text="Services">
                      My Space
                    </span>
                  </div>
                </a>
              </li>
              <li
                className={
                  navActive.includes("videos")
                    ? "nav-item nav-active"
                    : "nav-item"
                }
                onClick={() => navigateHandler("/videos")}
              >
                <a>
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="28"
                      viewBox="0 0 24 20"
                      fill="none"
                    >
                      <path
                        d="M12.6687 0C15.4946 0 17.4619 1.91747 17.6714 4.73042L20.7599 3.37761C22.0961 2.79341 23.5541 3.78602 23.6603 5.29436L23.6665 5.47062V13.7694C23.6665 15.3159 22.2579 16.3861 20.9141 15.9214L20.7594 15.8609L17.6714 14.508C17.4614 17.3191 15.4901 19.2388 12.6687 19.2388H5.35483C2.36221 19.2388 0.333496 17.0899 0.333496 14.0038V5.235C0.333496 2.14886 2.36221 0 5.35483 0H12.6687ZM12.6687 1.875H5.35483C3.32425 1.875 2.0835 3.18923 2.0835 5.235V14.0038C2.0835 16.0495 3.32425 17.3638 5.35483 17.3638H12.6687C14.6942 17.3638 15.94 16.0461 15.94 14.0038L15.9398 13.1468C15.9394 13.1335 15.9393 13.1201 15.9395 13.1067L15.94 5.235C15.94 3.18972 14.6985 1.875 12.6687 1.875ZM21.5007 5.08949L21.4215 5.11343L17.69 6.74625V12.4913L21.4211 14.1251C21.6317 14.2172 21.8593 14.0805 21.9073 13.857L21.9165 13.7694V5.47062C21.9165 5.22713 21.7119 5.05276 21.5007 5.08949Z"
                        fill="#666666"
                      />
                    </svg>
                  </div>
                  <div className="name">
                    <span data-text="Team">Videos</span>
                  </div>
                </a>
              </li>
              <li
                className={
                  navActive.includes("notifications")
                    ? "nav-item nav-active"
                    : "nav-item"
                }
                onClick={() => navigateHandler("/notifications")}
              >
                <a>
                  <div className="icon notify-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.0449 23.457C12.6493 24.1302 13.4251 24.5 14.2301 24.5H14.2313C15.0398 24.5 15.8191 24.1302 16.4246 23.4559C16.7489 23.0977 17.3019 23.0685 17.6601 23.3917C18.0194 23.7149 18.0486 24.269 17.7254 24.6272C16.7828 25.6737 15.5426 26.25 14.2313 26.25H14.2289C12.9211 26.2489 11.6833 25.6725 10.7441 24.626C10.4209 24.2679 10.4501 23.7137 10.8094 23.3917C11.1688 23.0674 11.7218 23.0965 12.0449 23.457ZM14.2882 1.16669C19.474 1.16669 22.9577 5.20569 22.9577 8.97752C22.9577 10.9177 23.4512 11.7402 23.975 12.6129C24.493 13.4739 25.0799 14.4515 25.0799 16.2995C24.6727 21.021 19.7435 21.406 14.2882 21.406C8.83286 21.406 3.90253 21.021 3.50002 16.3742C3.49653 14.4515 4.08336 13.4739 4.60136 12.6129L4.78423 12.305C5.23448 11.5312 5.6187 10.6894 5.6187 8.97752C5.6187 5.20569 9.10236 1.16669 14.2882 1.16669ZM14.2882 2.91669C10.2107 2.91669 7.3687 6.11102 7.3687 8.97752C7.3687 11.403 6.69553 12.5242 6.10053 13.5135C5.62336 14.308 5.24653 14.9357 5.24653 16.2995C5.44136 18.4999 6.89386 19.656 14.2882 19.656C21.6417 19.656 23.1397 18.4485 23.3334 16.2237C23.3299 14.9357 22.953 14.308 22.4759 13.5135C21.8809 12.5242 21.2077 11.403 21.2077 8.97752C21.2077 6.11102 18.3657 2.91669 14.2882 2.91669Z"
                        fill="black"
                        fillOpacity="0.6"
                      />
                    </svg>
                    {activeNotificationCount !== 0 && (
                      <span className="notify-count">
                        <p>{activeNotificationCount}</p>
                      </span>
                    )}
                  </div>
                  <div className="name">
                    <span data-text="Portfolio">Notification</span>
                  </div>
                </a>
              </li>

              <li
                className="nav-item dropdown mt-0"
                data-toggle="dropdown"
                ref={containerRef}
              >
                <div className="icon" style={{ textAlign: "center" }}>
                  <div className="sme-profile">
                    <img
                      className={`menu-img rounded-circle ml-1 dropdown-toggle ${
                        userData?.offerService ? "sme-mini-service" : null
                      }`}
                      src={userData?.picUrl ? userData?.picUrl : undrawProfile}
                    />
                    {userData?.offerService && (
                      <div
                        className="sme-mini-icon sme-nav-icon"
                        style={{
                          width: "15px",
                          height: "15px",

                          fontSize: "6px",
                        }}
                      >
                        SME
                      </div>
                    )}
                  </div>
                </div>
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="dropdown-toggle cursor-pointer"
                >
                  Me
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    className={isOpen ? "arrow-rotate" : ""}
                  >
                    <path
                      d="M2.60727 4.64914C2.76259 4.49381 3.00564 4.47969 3.17692 4.60678L3.22599 4.64914L6.99996 8.42291L10.7739 4.64914C10.9293 4.49381 11.1723 4.47969 11.3436 4.60678L11.3927 4.64914C11.548 4.80446 11.5621 5.04751 11.435 5.21879L11.3927 5.26786L7.30932 9.35119C7.154 9.50651 6.91094 9.52063 6.73967 9.39355L6.6906 9.35119L2.60727 5.26786C2.43641 5.097 2.43641 4.81999 2.60727 4.64914Z"
                      fill="black"
                    />
                  </svg>
                </a>
                {/* <Link onClick={authContext.logout} className="dropdown-toggle">
              Logout
            </Link> */}
                {isOpen && (
                  <UserMenu
                    isMenu={true}
                    showProfile={true}
                    toggleHandler={() => toggle()}
                  />
                )}
              </li>
            </ul>

            <div className="form-inline search-box" ref={searchContainerRef}>
              <div className="form-group has-search">
                <span className="form-control-feedback">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8.80401 1.5C12.8315 1.5 16.1075 4.776 16.1075 8.8035C16.1075 10.7037 15.3783 12.4367 14.185 13.7374L16.5331 16.0805C16.7528 16.3003 16.7536 16.6558 16.5338 16.8755C16.4243 16.9865 16.2796 17.0413 16.1356 17.0413C15.9923 17.0413 15.8483 16.9865 15.7381 16.877L13.3617 14.5073C12.1116 15.5084 10.5265 16.1077 8.80401 16.1077C4.77651 16.1077 1.49976 12.831 1.49976 8.8035C1.49976 4.776 4.77651 1.5 8.80401 1.5ZM8.80401 2.625C5.39676 2.625 2.62476 5.39625 2.62476 8.8035C2.62476 12.2108 5.39676 14.9827 8.80401 14.9827C12.2105 14.9827 14.9825 12.2108 14.9825 8.8035C14.9825 5.39625 12.2105 2.625 8.80401 2.625Z"
                      fill="#1C1C1C"
                      fillOpacity="0.7"
                    />
                  </svg>
                </span>
                <div className="search-container">
                  <div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search"
                      value={query}
                      onChange={handleInputChange}
                      onFocus={() => {
                        if (searchResults.length > 0) {
                          setIsContainerOpen(true); // Show suggestions only if results are not empty
                        }
                      }}
                    />
                    {/* <span className="search-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M13.0409 10.281C14.3279 10.281 15.3749 11.3227 15.3749 12.603C15.3749 13.8832 14.3279 14.925 13.0409 14.925C11.7532 14.925 10.7054 13.8832 10.7054 12.603C10.7054 11.3227 11.7532 10.281 13.0409 10.281ZM13.0409 11.406C12.3734 11.406 11.8304 11.943 11.8304 12.603C11.8304 13.2637 12.3734 13.8 13.0409 13.8C13.7077 13.8 14.2499 13.2637 14.2499 12.603C14.2499 11.943 13.7077 11.406 13.0409 11.406ZM7.56023 12.0696C7.87072 12.0696 8.12273 12.3216 8.12273 12.6321C8.12273 12.9426 7.87072 13.1946 7.56023 13.1946H2.83447C2.52397 13.1946 2.27197 12.9426 2.27197 12.6321C2.27197 12.3216 2.52397 12.0696 2.83447 12.0696H7.56023ZM4.58475 3C5.8725 3 6.9195 4.0425 6.9195 5.32275C6.9195 6.603 5.8725 7.644 4.58475 7.644C3.29775 7.644 2.25 6.603 2.25 5.32275C2.25 4.0425 3.29775 3 4.58475 3ZM4.58475 4.125C3.918 4.125 3.375 4.662 3.375 5.32275C3.375 5.98275 3.918 6.519 4.58475 6.519C5.25225 6.519 5.7945 5.98275 5.7945 5.32275C5.7945 4.662 5.25225 4.125 4.58475 4.125ZM14.3933 4.8003C14.7038 4.8003 14.9558 5.0523 14.9558 5.3628C14.9558 5.6733 14.7038 5.9253 14.3933 5.9253H9.66832C9.35782 5.9253 9.10582 5.6733 9.10582 5.3628C9.10582 5.0523 9.35782 4.8003 9.66832 4.8003H14.3933Z"
                          fill="#1C1C1C"
                          fillOpacity="0.7"
                        />
                      </svg>
                    </span> */}
                  </div>
                  {isContainerOpen && searchResults.length > 0 && (
                    <form
                      className="search-dropdown"
                      onSubmit={searchIndividualHandler}
                    >
                      <ul>
                        {searchResults.length > 0 &&
                          searchResults.slice(0, 3).map((result) => (
                            <li key={result.id}>
                              <Link
                                to={`/${result?.user_name}`}
                                target="_blank"
                              >
                                <div className="d-flex align-items-center">
                                  <div className="sme-profile">
                                    <img
                                      src={result?.pic_url || undrawProfile}
                                      alt="pic"
                                      className={`img-profile rounded-circle  ml-1 ${
                                        result?.offerService
                                          ? "sme-mini-service "
                                          : null
                                      }`}
                                    />
                                    {result?.offerService && (
                                      <div className="sme-mini-icon">SME</div>
                                    )}
                                  </div>
                                  <span
                                    className={
                                      result?.offerService ? "ml-2" : null
                                    }
                                  >
                                    {" "}
                                    {`${result?.fname || ""} ${
                                      result?.lname || ""
                                    }`}{" "}
                                  </span>
                                  <br />
                                </div>
                              </Link>
                            </li>
                          ))}
                      </ul>
                      {searchResults.length > 3 && (
                        <button
                          type="submit"
                          className="text-primary see-search-more cursor-pointer text-center"
                          ref={buttonRef}
                        >
                          See More
                        </button>
                      )}
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
      {/* {Object.keys(notificationData).length !== 0 && (
        <OtpVerification
          isOpen={isOtpModalOpen}
          onClose={() => setIsOtpModalOpen(false)}
          onSubmit={handleOtpSubmit}
          isOtpDisabled={isOtpDisabled}
          resendOtpHandler={null}
          title={`Enter the ${
            notificationData.refer_type === "startotp"
              ? "Start"
              : notificationData.refer_type === "endotp"
              ? "End"
              : null
          } session OTP`}
          description="Get the OTP from the participant and verify the session"
          isResend={false}
          btnTxt="Submit"
        />
      )} */}
    </div>
  );
};

export default Nav;
